export const thermageColor = '#45143F';
export const thermageLightColor = '#9b3e96';
export const clearColor = '#077FB2';
export const fraxelColor = '#691E33';
export const vaserColor = '#0079C1';
export const soltaColor = '#5A9BAB';
export const soltaGrey = '#656366';
